module.exports = __webpack_public_path__ + "media/VID03.4ee4b586.mp4";